export default {"src":"/_next/static/media/Checkicon.70444d47.svg","height":25,"width":24};